/** biome-ignore-all lint/complexity/noBannedTypes: none */
import { type RefObject, useEffect, useState } from "react";

export type PopupPosition =
	| {
			top: number;
			left: number;
			position: "absolute";
			zIndex: number;
	  }
	| {};

export const usePopupPosition = <T extends string | number>(
	refs: RefObject<Map<T, HTMLElement | null> | null>,
	selectedId: T,
): PopupPosition => {
	const [styles, setStyles] = useState<PopupPosition>({});

	useEffect(() => {
		const map = refs.current;
		if (map) {
			const currentRef = map.get(selectedId);
			if (currentRef) {
				const offset = currentRef.getBoundingClientRect();
				setStyles({
					top: offset.top + offset.height + window.scrollY,
					left: offset.left + 10 + window.scrollX,
					position: "absolute",
					zIndex: 9999,
				});
				return;
			}
		}
		setStyles({});
	}, [selectedId, refs]);

	return styles;
};
